// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__13IwG","messages":"Chat_messages__161IF","dateDivider":"Chat_dateDivider__2fago"};